module.exports = __webpack_public_path__ + "358beb189467d07bb2777b07e81bfac7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/windmill-empty.png
// module id = 334
// module chunks = 0